import { useEffect, useState } from 'react';
import { useFullScreenModal } from './useFullScreenModal';
import { apiAcceptance } from '../api/apiAcceptance.api';
import useAxiosPrivate from './useAxiosPrivate';

export const acceptanceType = {
  user_agreement: 'user_agreement',
  personal_data_processing_policy: 'personal_data_processing_policy',
  offer_for_the_provision_of_paid_services: 'offer_for_the_provision_of_paid_services',
};

export const resolverButtonText = {
  user_agreement: 'Пользовательского соглашения',
  personal_data_processing_policy: 'Обработку персональных данных',
  offer_for_the_provision_of_paid_services: 'Условия подписки',
};

export function useAcceptance({ typeAcceptance, onSuccess }) {
  const { Modal, Trigger, setOpen } = useFullScreenModal();

  const axiosPrivate = useAxiosPrivate();
  const [isLoading, setIsLoading] = useState(false);
  const [acceptance, setAcceptance] = useState(null);

  useEffect(() => {
    if (!typeAcceptance) return;
    setIsLoading(true);
    apiAcceptance
      .getAcceptanceDocumentByType(axiosPrivate, typeAcceptance)
      .then((res) => setAcceptance(res))
      .finally(() => setIsLoading(false));
  }, [typeAcceptance]);

  const onAccept = async () => {
    if (!acceptance) return;
    setIsLoading(true);
    await apiAcceptance.acceptAcceptance(axiosPrivate, acceptance._id).then(() => onSuccess?.());
    setIsLoading(false);
  };

  return {
    Trigger: () => (
      <Trigger className="underline text-[#A1F69E] cursor-pointer pointer-events-auto">
        {resolverButtonText[typeAcceptance] || 'Акцепт'}
      </Trigger>
    ),
    Modal: () =>
      acceptance && (
        <Modal title={acceptance.title}>
          <div className="whitespace-pre-line">{acceptance.content}</div>
        </Modal>
      ),
    onAccept: onAccept,
    isLoading,
    setOpen,
  };
}
